import * as classnames from "classnames";
import * as React from "react";

import { Icon, CliSupportBadge, Msg } from "..";
import { ApplicantChallengeModel } from "../../models";

/**
 * Enums
 */
import { ChallengeStyle } from "../../services/enums";
import MSG from "../../services/message";

/**
 * Prop interface
 */
export interface ApplicantChallengeMiniPropsForText {
  mode: "text";
  label: React.ReactNode;
  index?: number;
  size?: string;
  className?: string;
}

export interface ApplicantChallengeMiniPropsForChallenge {
  mode: "challenge";
  challenge: ApplicantChallengeModel;
  index?: number;
  size?: string;
  className?: string;
}

export type ApplicantChallengeMiniProps =
  | ApplicantChallengeMiniPropsForText
  | ApplicantChallengeMiniPropsForChallenge;

/**
 * React Component
 */
export default function ApplicantChallengeMini(
  props: ApplicantChallengeMiniProps,
) {
  const { size, index = 0, className } = props;
  const rootStyle = classnames("code-c-applicant-challenge-mini", {
    [`${className}`]: Boolean(className),
    [`is-${size}`]: Boolean(size),
  });
  if (props.mode === "challenge") {
    const { style, timeLimitMinutes, localExamEnabled } = props.challenge;
    const displayProblemKind = props.challenge.getStyleDisplayProblemKind();
    return (
      <div className={rootStyle}>
        <div className="code-c-applicant-challenge-mini__left">
          <div className="code-c-applicant-challenge-mini__left__number">
            {index + 1}.
          </div>
          <div className="code-c-applicant-challenge-mini__left__title">
            <span>{ChallengeStyle.toString(style)}</span>
            {displayProblemKind !== undefined && (
              <span className="code-c-applicant-challenge-mini__left__title__additional">
                {`${MSG.getMessageByKey(
                  "oParen",
                )}${displayProblemKind}${MSG.getMessageByKey("cParen")}`}
              </span>
            )}
          </div>
        </div>
        <div className="code-c-applicant-challenge-mini__right">
          {localExamEnabled && <CliSupportBadge />}
          <div className="code-c-applicant-challenge-mini__right__time">
            <Icon type="clock-o" />
            <span>
              {timeLimitMinutes ? (
                `${timeLimitMinutes} ${MSG.getMessageByKey("unit.mins")}`
              ) : (
                <Msg id="noLimit" />
              )}
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    const { label } = props;
    return (
      <div className={rootStyle}>
        <div className="code-c-applicant-challenge-mini__left">
          <div className="code-c-applicant-challenge-mini__left__number">
            {index + 1}.
          </div>
          <div className="code-c-applicant-challenge-mini__left__title">
            {label}
          </div>
        </div>
        <div className="code-c-applicant-challenge-mini__right" />
      </div>
    );
  }
}
